import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'react-circular-progressbar/dist/styles.css';

ReactDOM.render(<App />, document.getElementById('root'));
